import { Injectable } from '@angular/core';
import { GenericResponse } from '../business-entities/generic-response';
import { UserViseAppointmentDataService } from '../data-services/user-vise-appointment-data.service'
import { CdssAppointmentModel, UserViseAppointmentModel } from '../business-entities/user-vise-appointment-model';

@Injectable({
  providedIn: 'root'
})
export class UserViseAppointmentService {
  filterTypeId: number = 0;
  userViseAppointmentList:UserViseAppointmentModel[]
  cdssAppointmentList: CdssAppointmentModel[]
  constructor(
    private service:UserViseAppointmentDataService
  ) { }
  async getUserViseAppointmentList(data):Promise<any>{
    await this.service.getUserViseAppointmentList(data).then(
      (res:GenericResponse<Array<UserViseAppointmentModel>>)=>{
        this.userViseAppointmentList = res.responseObject;
      }
    );
    return this.userViseAppointmentList;
  }

  async getCdssAppointmentList(data):Promise<any>{
    await this.service.getCdssAppointmentList(data).then(
      (res:GenericResponse<Array<CdssAppointmentModel>>)=>{
        this.cdssAppointmentList = res.responseObject;
      }
    );
    return this.cdssAppointmentList;
  }
  
}
